import * as React from "react";
import { MapPin, Phone, Map as MapIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const locations = [{
  id: "limassol",
  city: "Limassol",
  title: "Limassol Clinic",
  address: "Foloune House, Gladstonos 120, Unit 5, Limassol 3032, Cyprus",
  phone: "+357 96 117140",
  mapSrc: "https://www.google.com/maps?q=Bodywerks%20Gladstonos%20120%20Limassol&output=embed",
  directionsUrl: "https://www.google.com/maps/search/?api=1&query=Bodywerks%20Gladstonos%20120%20Limassol"
}, {
  id: "nicosia",
  city: "Nicosia",
  title: "Nicosia Clinic",
  address: "Alexiou Building, Ifigenias 62, 3rd Floor, Nicosia 2003, Cyprus",
  phone: "+357 99 433537",
  mapSrc: "https://www.google.com/maps?q=Ifigenias%2062%20Nicosia%202003&output=embed",
  directionsUrl: "https://www.google.com/maps/search/?api=1&query=Ifigenias%2062%20Nicosia%202003"
}];
export default function Maps() {
  return <section id="maps" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Our Locations
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Visit us at our state-of-the-art clinics in Limassol and Nicosia. We look forward to welcoming you.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {locations.map((location, i) => <Card key={location.id} data-index={i} className="bg-card text-card-foreground gap-6 rounded-xl flex h-full flex-col overflow-hidden ![padding:0px_0px_24px_0px]">
              <CardHeader className="@container/card-header @container/card-header @container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 bg-muted/50 ![padding:0px_24px_0px_0px]">
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle className="font-semibold text-2xl !rounded-lg">{location.title}</CardTitle>
                    <CardDescription className="mt-1 flex items-center gap-1.5 text-base">
                      <MapPin className="size-4 shrink-0" />
                      {location.address}
                    </CardDescription>
                  </div>
                </div>
                <div className="text-muted-foreground mt-4 flex items-center gap-1.5 text-sm">
                  <Phone className="size-4 shrink-0" />
                  <span>{location.phone}</span>
                </div>
              </CardHeader>
              <CardContent className="flex-grow p-0">
                <div className="relative h-64 w-full sm:h-80 lg:h-96">
                  <iframe src={location.mapSrc} title={`${location.title} Map`} className="absolute inset-0 h-full w-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                </div>
              </CardContent>
              <CardFooter className="flex items-center [.border-t]:pt-6 p-6 !bg-transparent !w-[500px]">
                <Button asChild className="w-full sm:w-auto" variant="default">
                  <Link to={location.directionsUrl} newTab className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary text-primary-foreground shadow-xs h-9 px-4 py-2 has-[>svg]:px-3 w-full !rounded-none disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 sm:w-auto">
                    <MapIcon className="mr-2 size-4" />
                    Get Directions to {location.city}
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}